import axios from "axios";
import store from "../redux/store";

const baseUrl = String(process.env.REACT_APP_API_URL);

axios.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(
      "accessToken" + process.env.REACT_APP_LS_SALT
    );
    if (accessToken) {
      config.headers = {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      };
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    let refreshToken = localStorage.getItem(
      "refreshToken" + process.env.REACT_APP_LS_SALT
    );
    if (
      refreshToken &&
      error.response.status === 440 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      return axios
        .post(`${baseUrl}/auth/refresh`, { refreshToken: refreshToken })
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem(
              "accessToken" + process.env.REACT_APP_LS_SALT,
              res.data.accessToken
            );
            localStorage.setItem(
              "refreshToken" + process.env.REACT_APP_LS_SALT,
              res.data.refreshToken
            );
            return axios(originalRequest);
          }
        })
        .catch((e) => {
          if (e.response.status === 400 || e.response.status === 401) {
            store.dispatch({
              type: "auth/logout",
            });
          }

          return Promise.reject(e);
        });
    }
    return Promise.reject(error);
  }
);

const api = {
    
  login: (body) => {
    return axios.post(`${baseUrl}/auth`, body);
  },
  checkAuth: () => {
    return axios.post(`${baseUrl}/auth/check`);
  },
  datosUsuario: () => {
    return axios.post(`${baseUrl}/auth/usuario`);
  },
  menuUsuario: () => {
    return axios.post(`${baseUrl}/auth/menu`);
  },
  accionesUsuario: () => {
    return axios.post(`${baseUrl}/auth/acciones`);
  },
  
  refreshToken: (body) => {
    return axios.post(`${baseUrl}/auth/refresh_token`, body);
  },

  prueba: (body) => {
    return axios.post(`${baseUrl}/prueba`, body);
  },

  listaNotificaciones: (body) => {
    return axios.post(`${baseUrl}/alumno/notificaciones`, body);
  },

  listaCursosDisponibles: (body) => {
    return axios.post(`${baseUrl}/alumno/cursos/disponibles`, body);
  },

  listaCursosInscripto: (body) => {
    return axios.post(`${baseUrl}/alumno/cursos/listadoInscriptos`, body);
  },

  listaHistorialCursos: (body) => {
    return axios.post(`${baseUrl}/alumno/cursos/listadohistorial`, body);
  },

  mostrarDetalleCurso: (body) => {
    return axios.post(`${baseUrl}/alumno/cursos/detalle`, body);
  },

  listaPlantas: (body) => {
    return axios.post(`${baseUrl}/alumno/plantas`, body);
  },

  listaLocalidades: (body) => {
    return axios.post(`${baseUrl}/alumno/localidades`, body);
  },

  listaFormacionAcademica: (body) => {
    return axios.post(`${baseUrl}/alumno/formacionAcademica`, body);
  },

  listaEstadoFormacionAcademica: (body) => {
    return axios.post(`${baseUrl}/alumno/estadoFormacionAcademica`, body);
  },

  listaDireccionAdministracion: (body) => {
    return axios.post(`${baseUrl}/alumno/direccionAdministracion/`+body, body);
  },

  listaAreasInteres: (body) => {
    return axios.post(`${baseUrl}/alumno/areasInteres`, body);
  },

  listaAreasInteresAlumno: (body) => {
    return axios.post(`${baseUrl}/alumno/areasInteresAlumno`, body);
  },

  mostrarDatosPersonales: (body) => {
    return axios.post(`${baseUrl}/alumno/datosPersonales`, body);
  },

  inscribirACurso: (body) => {
    return axios.post(`${baseUrl}/alumno/cursos/inscribirACurso`, body);
  },

  eliminarInscripcionCurso: (body) => {
    return axios.post(`${baseUrl}/alumno/cursos/eliminarInscripcionCurso`, body);
  },

  modificarDatosPersonales: (body) => {
    return axios.post(`${baseUrl}/alumno/modificarDatosPersonales`, body);
  },

  verificarExisteAlumno: (body) => {
    return axios.post(`${baseUrl}/alumno/verificarAlumno/`+body, body);
  },

  verificarMailAlumno: (body) => {
    return axios.post(`${baseUrl}/alumno/verificarMailAlumno`, body);
  },

  inscribirAPlan: (body) => {
    return axios.post(`${baseUrl}/alumno/inscribir`, body);
  },

  saludo: (body) => {
    return axios.post(`${baseUrl}/alumno/saludo`, body);
  },

  modificarPass: (body) => {
    return axios.post(`${baseUrl}/alumno/modificarPass`, body);    
  },

  agregarVistoMsj: (body) => {
    return axios.post(`${baseUrl}/alumno/agregarVistoMsj`, body);    
  },
  
  obtenerCodigo: (body) => {
    return axios.post(`${baseUrl}/alumno/obtenerCodigoRestablecer`, body);    
  },

  validarCodigo: (body) => {
    return axios.post(`${baseUrl}/alumno/validarCodigoRestablecer`, body);    
  },

  reestablecerPass: (body) => {
    return axios.post(`${baseUrl}/alumno/modificarPassRestablecer`, body);    
  },

  listaCantNotificaciones: (body) => {
    return axios.post(`${baseUrl}/alumno/cantNotificaciones`, body);    
  },


  
  
};

export default api;